import React from 'react'
import PropTypes from 'prop-types'
import { Text, Format, InlineTextLock } from '../..'

const LockableInlineCurrencyText = ({
  currency,
  variant = 'success',
  locked = false,
}) => (
  <Text element='span' variant={variant} nowrap>
    <Format.Currency>
      <InlineTextLock enabled={locked}>
        {Format.number(Math.round(currency))}
      </InlineTextLock>
    </Format.Currency>
  </Text>
)

LockableInlineCurrencyText.propTypes = {
  currency: PropTypes.number,
  variant: PropTypes.oneOf(Text.Variants),
  locked: PropTypes.bool,
}

export default LockableInlineCurrencyText
